const Sponsor = () => {
    return (
        <div id="our-sponsors" className="section sponsor">
            <h2>Our Sponsor, Transfer Agent & Legal Counsel</h2>

            <div className="our-sponsors-content">
                <div className="our-sponsors-content-item">
                    <p>SPONSOR/ADVISOR:</p>
                    <h3>Bank Investment Maxim Group LLC</h3>
                    <p>300 PARK AVE 16TH FLOOR,<br />NEW YORK, NY 10022<br />MAXIMGRP.COM</p>
                </div>

                <div className="our-sponsors-content-item middle">
                    <p>TRANSFER AGENT:</p>
                    <h3>vStock</h3>
                    <p>18 LAFAYETTE PL,WOODMERE, NY 11598<br />VSTOCKTRANSFER.COM</p>
                </div>

                <div className="our-sponsors-content-item">
                    <p>LEGAL/ADVISOR:</p>
                    <h3>Anthony, Linder
                    & Cacomanolis, PLLC</h3>
                    <p>1700 PALM BEACH LAKES BLVD.,
                    SUITE 820<br />WEST PALM BEACH, FL 33401</p>
                </div>
            </div>
        </div>
    );
};

export default Sponsor;